import React, { useState, useEffect } from 'react';
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.css';
import { Container, Form, Button, Card, Spinner } from 'react-bootstrap';
import ManagerService from '../../services/ManagerService'; 
import LoadThongTinService from '../../services/LoadThongTinService';
import * as XLSX from 'xlsx';

const TimTheoBKSComponent = () => {
  const [bienKiemSoat, setBienKiemSoat] = useState('');
  const [startDay, setStartDay] = useState('');
  const [endDay, setEndDay] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hotInstance, setHotInstance] = useState(null);
  const [dataBackup, setDataBackup] = useState([]);
  const [updatedData, setUpdatedData] = useState([]); // Biến mới để lưu dữ liệu đã sửa đổi
  const [bienKiemSoatList, setBienKiemSoatOptions] = useState([]);
  const [maBuuCucList, setBuuCucOptions] = useState([]);
  const [isSearchCompleted, setIsSearchCompleted] = useState(false);
  const colHeadersConfig = [
    'Biển kiểm soát', 'Mã chuyến', 'Ngày khởi hành', 'Loại chạy', 'Thời gian nhập liệu', 'Giờ đi', 'Giờ đến', 'Điểm đi', 'Điểm đến', 'Km đầu', 'Km cuối', 'Tổng km đã di chuyển', 'Số kiện tải', 'Trọng lượng lên xe', 'Trọng lượng xuống xe', 'Đơn vị sử dụng', 'Ghi chú', 'Username'
  ];

  useEffect(() => {
    const fetchBienKiemSoat = async () => {
      try {
        const response = await LoadThongTinService.getBienKiemSoat();
        setBienKiemSoatOptions(response.data);
      } catch (error) {
        console.error('Lỗi khi tải biển kiểm soát:', error);
      }
    };

    const fetchMaBuuCuc = async () => {
      try {
        const response = await LoadThongTinService.getMaBuuCuc();
        setBuuCucOptions(response.data);
      } catch (error) {
        console.error('Lỗi khi tải mã bưu cục:', error);
      }
    };

    fetchBienKiemSoat();
    fetchMaBuuCuc();
  }, []);

  const handleTimKiem = async () => {
    if (!bienKiemSoat || !startDay || !endDay) {
      alert('Vui lòng nhập biển kiểm soát và chọn ngày');
      return;
    }

    setIsLoading(true);
    try {
      const result = await ManagerService.timTheoBKS(bienKiemSoat, startDay, endDay);
      if (result.data) {
        setDataBackup(result.data);
        setUpdatedData(result.data); // Khởi tạo updatedData bằng dữ liệu ban đầu
        setIsSearchCompleted(true);
      } else {
        alert('Không tìm thấy dữ liệu');
        setIsSearchCompleted(false);
      }
    } catch (error) {
      console.error('Lỗi khi tìm theo biển kiểm soát:', error);
      alert('Không thể tìm thông tin.');
      setIsSearchCompleted(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (dataBackup.length > 0) {
      renderTable({ data: dataBackup });
    }
  }, [dataBackup]);

  const renderTable = (data) => {
    const container = document.getElementById('handsontable');

    if (hotInstance && !hotInstance.isDestroyed) {
      hotInstance.destroy();
    }

    const columnsConfig = [
      { data: 'bien_kiem_soat', type: 'dropdown', source: bienKiemSoatList, allowInvalid: false },
      { data: 'ma_chuyen', type: 'text', readOnly: false },
      { data: 'ngay_khoi_hanh', type: 'text', readOnly: true },
      { data: 'loai_chay', type: 'dropdown', source: ["Kết Nối Đi", "Kết Nối Về", "Phát Hàng", "Phục Vụ Thu Điểm Cuối", "Phục Vụ Phát Điểm Cuối", "Kinh Doanh", "Sửa Chữa", "Đăng Kiểm", "Khác"], allowInvalid: false },
      { data: 'thoi_gian_nhap_lieu', type: 'text', readOnly: true },
      { data: 'gio_di', type: 'text', validator: (value, callback) => { const timePattern = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/; callback(timePattern.test(value)); }, placeholder: 'HH:MM', allowInvalid: false },
      { data: 'gio_den', type: 'text', validator: (value, callback) => { const timePattern = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/; callback(timePattern.test(value)); }, placeholder: 'HH:MM', allowInvalid: false },
      { data: 'diem_di', type: 'dropdown', source: maBuuCucList, allowInvalid: false },
      { data: 'diem_den', type: 'dropdown', source: maBuuCucList, allowInvalid: false },
      { data: 'km_dau', type: 'numeric', readOnly: false },
      { data: 'km_cuoi', type: 'numeric', readOnly: false },
      { data: 'tong_km_di_chuyen', type: 'numeric', readOnly: true },
      { data: 'so_kien_tai', type: 'numeric', readOnly: false },
      { data: 'trong_luong_len_xe', type: 'numeric', readOnly: false },
      { data: 'trong_luong_xuong_xe', type: 'numeric', readOnly: false },
      { data: 'don_vi_su_dung', type: 'dropdown', source: maBuuCucList, allowInvalid: false },
      { data: 'ghi_chu', type: 'text', readOnly: false },
      { data: 'username', type: 'text', readOnly: true },
    ];

    const hot = new Handsontable(container, {
      data: data.data,
      colHeaders: colHeadersConfig,
      rowHeaders: true,
      contextMenu: true,
      filters: true,
      dropdownMenu: true,
      stretchH: 'all',
      autoColumnSize: true,
      manualRowResize: true,
      manualColumnResize: true,
      allowInsertRow: false,
      columns: columnsConfig,
      licenseKey: 'non-commercial-and-evaluation',
      afterChange: (changes, source) => {
        if (source === 'loadData') return;

        if (changes) {
          const newUpdatedData = [...updatedData];
          changes.forEach(([row, prop, oldValue, newValue]) => {
            if (oldValue !== newValue) {
              newUpdatedData[row] = { ...newUpdatedData[row], [prop]: newValue };
            }
          });
          setUpdatedData(newUpdatedData); // Cập nhật biến updatedData khi có thay đổi
        }
      },
    });

    setHotInstance(hot);
  };

  const handleExportExcel = () => {
    if (hotInstance) {
      const data = hotInstance.getData();
      const headers = [colHeadersConfig]; // Thêm header vào dữ liệu
      const dataWithHeaders = headers.concat(data); // Kết hợp header với dữ liệu
  
      const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Chuyển đổi dữ liệu thành worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'Thong_tin_tai_xe_nhap_theo_BKS.xlsx');
    }
  };

  const handleSaveChanges = async () => {
    try {
      await ManagerService.suaTheoBKS(dataBackup, updatedData);
      alert('Lưu thay đổi thành công');
    } catch (error) {
      console.error('Lỗi khi lưu thay đổi:', error);
      alert('Lưu thay đổi thất bại');
    }
  };

  return (
    <Container fluid className="mt-5 tim-theo_bks">
      <Card className="p-4 shadow-sm mb-4 full-width-card">
        <h1 className="text-center mb-4">Tìm thông tin theo biển kiểm soát</h1>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Biển kiểm soát</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nhập biển kiểm soát"
              value={bienKiemSoat}
              onChange={(e) => setBienKiemSoat(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Ngày bắt đầu</Form.Label>
            <Form.Control
              type="date"
              value={startDay}
              onChange={(e) => setStartDay(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Ngày kết thúc</Form.Label>
            <Form.Control
              type="date"
              value={endDay}
              onChange={(e) => setEndDay(e.target.value)}
            />
          </Form.Group>
          <Button variant="danger" onClick={handleTimKiem} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{' '}
                Đang tìm...
              </>
            ) : 'Tìm'}
          </Button>
        </Form>
      </Card>

      <Card className="p-4 shadow-sm full-width-card">
        <h2 className="text-center">Kết quả tìm kiếm</h2>
        {isSearchCompleted && (
          <div className="d-flex justify-content-center mb-3">
            <Button variant="success" onClick={handleExportExcel} disabled={!hotInstance}>
              Xuất Excel
            </Button>
            <Button variant="primary" onClick={handleSaveChanges} className="ms-3">
              Lưu sửa đổi
            </Button>
          </div>
        )}
        <div id="handsontable" style={{ width: '100%', height: '400px', marginTop: '20px', overflowX: 'auto' }}></div>
      </Card>
    </Container>
  );
};

export default TimTheoBKSComponent;
